$(document).ready(function() {
    // Define checkAndSetMeasurementOptions as a global function
    window.checkAndSetMeasurementOptions = function() {
        const myPOF = localStorage.getItem("patternOnFile");
        const tailor2Complete = localStorage.getItem("tailor2Complete");
        const bdjUserData = localStorage.getItem("bdjUserData");
        const whiteGlove = localStorage.getItem("whiteGlove"); // Retrieve whiteGlove from localStorage
        const savedMeasurementsRadio = $('input[type="radio"][value="saved-measurements"]');

        console.log("Running checkAndSetMeasurementOptions...");
        console.log("LocalStorage values at start:", { myPOF, tailor2Complete, bdjUserData, whiteGlove });

        // Handle White Glove selection on page load
        if (whiteGlove === "Contact ASAP for measurements.") {
            showMeasurementStatusNeeded(); // Show needed status for White Glove Service
            console.log("White Glove Service active on page load. Showing needed status.");
            return; // Exit early as White Glove is active
        }

        // Display needed icon if no valid data is present and do not preselect any radio buttons
        if (bdjUserData) {
            updateLocalStorage("tailor2Complete", "Yes");
            updateLocalStorage("whiteGlove", "");
            preselectMeasurements(savedMeasurementsRadio, true);
            showMeasurementStatusSaved(); // Show saved status icon
            console.log("User data found. Setting tailor2Complete to 'Yes' and showing saved status.");
        } else if (myPOF && tailor2Complete === "No") {
            showMeasurementStatusNeeded(); // Show needed status icon
            $('input[type="radio"]').prop('checked', false); // No radio button selected
            console.log("Pattern on file with tailor2Complete set to 'No'. Showing needed status. No radio buttons preselected.");
        } else {
            $('input[type="radio"]').prop('checked', false); // No radio button selected
            showMeasurementStatusNeeded(); // Show needed status icon
            console.log("No user data or valid pattern on file. Showing needed status.");
        }

        // Ensure the correct toggle is shown for the preselected option
        updateToggleVisibility();
    };

    // Helper function to preselect measurements and toggle visibility
    function preselectMeasurements(radioElement, isNew) {

        var tailorCheck = localStorage.getItem("tailor2Complete");
        console.log("tailorCheck = "+tailorCheck);
        if(tailorCheck == "Yes"){
             $('.saveMeasureToggle .useNew').show();
             $('.saveMeasureToggle .usePattern').hide();
        } else  if(tailorCheck != "Yes"){
             $('.saveMeasureToggle .useNew').hide();
             $('.saveMeasureToggle .usePattern').show();
        }
    }

    // Helper function to update visibility of .tapeToggle elements
    function updateToggleVisibility() {
        $('.tapeToggle').hide();
        $('input[type="radio"]:checked').closest('.radio-option').find('.tapeToggle').show();
        console.log("Toggle visibility set based on preselected option.");
    }

    // Function to show saved status in prod measurement status
    function showMeasurementStatusSaved() {
        $(".prod_measurement-status .m-needed-ico").hide();
        $(".prod_measurement-status .m-saved-ico").show();
        console.log("Measurement status: saved icon displayed.");
    }

    // Function to show needed status in prod measurement status
    function showMeasurementStatusNeeded() {
        $(".prod_measurement-status .m-saved-ico").hide();
        $(".prod_measurement-status .m-needed-ico").show();
        console.log("Measurement status: needed icon displayed.");
    }

    // Run the check and set options on page load after a 1-second delay
    setTimeout(() => {
        console.log("Running checkAndSetMeasurementOptions on page load...");
        checkAndSetMeasurementOptions();
    }, 1000);

    // Handle the click event for the radio buttons
    $('.measurementPath input[type="radio"]').on('change', function() {
        const selectedRadio = $(this).val();
        const myPOF = localStorage.getItem("patternOnFile");
        const tailor2Complete = localStorage.getItem("tailor2Complete");
        const bdjUserData = localStorage.getItem("bdjUserData");
        const whiteGlove = localStorage.getItem("whiteGlove");

        console.log("Radio button changed to:", selectedRadio);
        console.log("Current LocalStorage values:", { myPOF, tailor2Complete, bdjUserData, whiteGlove });

        $('.tapeToggle').hide();
        $(this).closest('.radio-option').find('.tapeToggle').show();

        // Toggle based on "saved-measurements" selection
        if (selectedRadio === 'saved-measurements') {
            showMeasurementStatusSaved(); // Show saved icon
            console.log("Selected 'saved-measurements' option. Showing saved status.");
            
            preselectMeasurements(null, true);
            updateLocalStorage("patternOnFile", "Use Pattern on File.");
            updateLocalStorage("whiteGlove", ""); // Clear white glove setting
        }

        // Handle "get-measurements" selection
        if (selectedRadio === 'get-measurements') {
            updateLocalStorage("whiteGlove", "");
            if (tailor2Complete !== "Yes" && !bdjUserData) {
                showMeasurementStatusNeeded(); // Show needed status
                console.log("Selected 'get-measurements'. tailor2Complete is not 'Yes' and no bdjUserData. Showing needed status.");
            } else if (tailor2Complete === "Yes" || bdjUserData) {
                showMeasurementStatusSaved(); // Show saved status
                console.log("Selected 'get-measurements'. tailor2Complete is 'Yes' or bdjUserData exists. Showing saved status.");
            }
        }

        // Handle "white-glove-service" selection
        if (selectedRadio === 'white-glove-service') {
            updateLocalStorage("whiteGlove", "Contact ASAP for measurements.");
            updateLocalStorage("patternOnFile", ""); // Clear pattern on file
            showMeasurementStatusNeeded(); // Show needed status
            console.log("White glove service selected. Showing needed status.");
        }
    });

    // Helper function to update localStorage with logging
    function updateLocalStorage(key, value) {
        console.log(`Updating localStorage for ${key}: ${value}`);
        localStorage.setItem(key, value);
    }

    // Handling checkbox click for boldProdOptions
    $(".pdp2024 .boldProdOptions").on("click", function() {
        console.log("Checkbox click detected in boldProdOptions.");
        setTimeout(() => {
            const elementValue = $('.pdp2024 .boldProdOptions .bold_option_checkbox input[type="hidden"]').val();
            showHidePocket(elementValue);
        }, 50);
    });

    // Function to show/hide pocket image based on checkbox value
    function showHidePocket(elementValue) {
        console.log("Running showHidePocket with elementValue:", elementValue);
        $(".pdp2024 .watchPocketImg").toggle(elementValue === "✓");
        console.log(`Pocket image visibility set to ${elementValue === "✓" ? "visible" : "hidden"}`);
    }
});
